import Drift from "drift-zoom";

const imgZoomContainers = document.querySelectorAll(".imgZoomContainer");

if (imgZoomContainers) {

	imgZoomContainers.forEach( (item) => {
		const demoTrigger = item.querySelector(".imgZoom img");
		const imgZoom = item.querySelector(".imgZoom");

		const drift = new Drift(demoTrigger, {
			paneContainer: item,
			zoomFactor: 2.5,
			inlinePane: false,
			inlineOffsetY: 0,
			containInline: false,
			hoverBoundingBox: false,
			touchBoundingBox: false,
			boundingBoxContainer: imgZoom
		});

		function disableZoom(el) {
			if (el === undefined) return;

			if (el.classList.contains('enabled')) {
				drift.disable();
				el.classList.remove('enabled');
			}
		}

		function enableZoom(el) {
			if (el === undefined) return;

			if (!el.classList.contains('enabled')) {
				drift.enable();
				el.classList.add('enabled');
			}
		}

		imgZoom.addEventListener('click', function (e) {
			e.stopPropagation();

			if (window.innerWidth >= 960) {
				enableZoom(this);
			}
		});

		imgZoom.addEventListener('mouseleave', (e) => {
			e.stopPropagation();

			if (window.innerWidth >= 960) {
				disableZoom(this);
			}
		});
	})
}
